import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { isOperatingCountry, languageFor } from "@nh/shared";
import { useAuth } from "@/features/auth/auth.context";
import { readChosenLanguage } from "@/shared/i18n/useLanguage";
import { useConnectionCountry } from "@/features/shop/useConnectionCountry";

/**
 * El idioma de la pantalla, por omisión, lo decide el PAÍS: el de la
 * cuenta si lo hay (Anahí, 1-sep), y si no, el de la CONEXIÓN (Anahí,
 * 14-sep: quien entra desde Estados Unidos ve inglés y dólares).
 *
 * ── Lo que cambió el 14-sep ──────────────────────────────────────────
 * «Con la posibilidad de cambiar el idioma, pero no los precios.» El
 * idioma volvió a ser una preferencia —el selector está en la barra
 * superior— y la MONEDA es lo que ya no se toca: la fija el país de
 * conexión en `useShopCurrency`. Que el idioma se cambie ya no
 * desalinea el cobro, porque el cobro ya no depende del idioma.
 *
 * Por eso este efecto solo pone el idioma por omisión: si la persona
 * eligió uno (`readChosenLanguage`), se respeta y no se le vuelve a
 * cambiar al entrar ni al cambiar de país.
 */
export function useCountryLanguage(): void {
  const { user } = useAuth();
  const { i18n } = useTranslation();
  const connection = useConnectionCountry();

  useEffect(() => {
    const chosen = readChosenLanguage();
    const country = isOperatingCountry(user?.country) ? user.country : connection;
    const idioma = chosen ?? languageFor(country);
    if (i18n.language !== idioma) void i18n.changeLanguage(idioma);
  }, [user?.country, connection, i18n]);
}
